import {
  INotificationSettingsForm,
  INotificationSettingsQuery,
  ICreateUserSpecification,
} from "services/configuration/notifications/types";
import { DELIVERY_STATUS_NOTIFICATION_TYPE_ID } from "services/configuration/notifications/constants";

export const userSpecificationFormToQuery = (
  notificationForm: INotificationSettingsForm,
  userId: string
): ICreateUserSpecification => {
  const { mockedNotifications } = notificationForm;

  const notificationsArray: INotificationSettingsQuery[] = [];

  Object.keys(mockedNotifications).forEach((key) => {
    const domain = mockedNotifications[key];

    if (domain.notifications && Array.isArray(domain.notifications)) {
      const transformedNotifications = domain.notifications
        .filter((notification) => notification.isSelected)
        .map((notification) => ({
          notificationTypeId: notification.id,
          sendEmail: notification.sendEmail,
          ...(notification.id === DELIVERY_STATUS_NOTIFICATION_TYPE_ID
            ? {
                deliveryStatusIds: notification.deliveryStatusIds?.length
                  ? notification.deliveryStatusIds
                  : null,
              }
            : {}),
        }));

      notificationsArray.push(...transformedNotifications);
    }
  });

  return {
    userId,
    userSpecifications: notificationsArray,
  };
};
